// extracted by mini-css-extract-plugin
export var hidden = "_s3-0";